{
  /* 
          To change the color of an SVG in React, ensure the SVG uses `fill="currentColor"`, 
          then set the color using a CSS style or the `color` style property.
        */
}
export const VolumeDownIcon = ({ width = 20, height = 20 }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 256 256"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    stroke="currentColor"
    stroke-width="5"
    class="raster-icon"
    aria-label="volume1"
  >
    <rect x="112" y="40" width="14" height="14" rx="0"></rect>
    <rect x="112" y="56" width="14" height="14" rx="0"></rect>
    <rect x="112" y="88" width="14" height="14" rx="0"></rect>
    <rect x="112" y="72" width="14" height="14" rx="0"></rect>
    <rect x="112" y="136" width="14" height="14" rx="0"></rect>
    <rect x="112" y="104" width="14" height="14" rx="0"></rect>
    <rect x="32" y="136" width="14" height="14" rx="0"></rect>
    <rect x="112" y="120" width="14" height="14" rx="0"></rect>
    <rect x="32" y="120" width="14" height="14" rx="0"></rect>
    <rect x="32" y="104" width="14" height="14" rx="0"></rect>
    <rect x="80" y="168" width="14" height="14" rx="0"></rect>
    <rect x="96" y="184" width="14" height="14" rx="0"></rect>
    <rect x="80" y="72" width="14" height="14" rx="0"></rect>
    <rect x="96" y="56" width="14" height="14" rx="0"></rect>
    <rect x="112" y="168" width="14" height="14" rx="0"></rect>
    <rect x="112" y="152" width="14" height="14" rx="0"></rect>
    <rect x="144" y="88" width="14" height="14" rx="0"></rect>
    <rect x="160" y="136" width="14" height="14" rx="0"></rect>
    <rect x="160" y="104" width="14" height="14" rx="0"></rect>
    <rect x="160" y="120" width="14" height="14" rx="0"></rect>
    <rect x="144" y="152" width="14" height="14" rx="0"></rect>
    <rect x="64" y="152" width="14" height="14" rx="0"></rect>
    <rect x="64" y="88" width="14" height="14" rx="0"></rect>
    <rect x="32" y="88" width="14" height="14" rx="0"></rect>
    <rect x="48" y="88" width="14" height="14" rx="0"></rect>
    <rect x="48" y="152" width="14" height="14" rx="0"></rect>
    <rect x="32" y="152" width="14" height="14" rx="0"></rect>
    <rect x="112" y="184" width="14" height="14" rx="0"></rect>
    <rect x="112" y="200" width="14" height="14" rx="0"></rect>
  </svg>
);

export const VolumeUpIcon = ({ width = 20, height = 20 }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 256 256"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    stroke="currentColor"
    stroke-width="5"
    class="raster-icon"
    aria-label="volume2"
  >
    <rect x="112" y="40" width="14" height="14" rx="0"></rect>
    <rect x="112" y="56" width="14" height="14" rx="0"></rect>
    <rect x="112" y="88" width="14" height="14" rx="0"></rect>
    <rect x="112" y="72" width="14" height="14" rx="0"></rect>
    <rect x="112" y="136" width="14" height="14" rx="0"></rect>
    <rect x="112" y="104" width="14" height="14" rx="0"></rect>
    <rect x="32" y="136" width="14" height="14" rx="0"></rect>
    <rect x="112" y="120" width="14" height="14" rx="0"></rect>
    <rect x="32" y="120" width="14" height="14" rx="0"></rect>
    <rect x="32" y="104" width="14" height="14" rx="0"></rect>
    <rect x="80" y="168" width="14" height="14" rx="0"></rect>
    <rect x="96" y="184" width="14" height="14" rx="0"></rect>
    <rect x="80" y="72" width="14" height="14" rx="0"></rect>
    <rect x="96" y="56" width="14" height="14" rx="0"></rect>
    <rect x="112" y="168" width="14" height="14" rx="0"></rect>
    <rect x="112" y="152" width="14" height="14" rx="0"></rect>
    <rect x="144" y="88" width="14" height="14" rx="0"></rect>
    <rect x="160" y="136" width="14" height="14" rx="0"></rect>
    <rect x="160" y="104" width="14" height="14" rx="0"></rect>
    <rect x="160" y="120" width="14" height="14" rx="0"></rect>
    <rect x="144" y="152" width="14" height="14" rx="0"></rect>
    <rect x="200" y="88" width="14" height="14" rx="0"></rect>
    <rect x="184" y="72" width="14" height="14" rx="0"></rect>
    <rect x="184" y="168" width="14" height="14" rx="0"></rect>
    <rect x="200" y="136" width="14" height="14" rx="0"></rect>
    <rect x="200" y="104" width="14" height="14" rx="0"></rect>
    <rect x="200" y="120" width="14" height="14" rx="0"></rect>
    <rect x="200" y="152" width="14" height="14" rx="0"></rect>
    <rect x="64" y="152" width="14" height="14" rx="0"></rect>
    <rect x="64" y="88" width="14" height="14" rx="0"></rect>
    <rect x="32" y="88" width="14" height="14" rx="0"></rect>
    <rect x="48" y="88" width="14" height="14" rx="0"></rect>
    <rect x="48" y="152" width="14" height="14" rx="0"></rect>
    <rect x="32" y="152" width="14" height="14" rx="0"></rect>
    <rect x="112" y="184" width="14" height="14" rx="0"></rect>
    <rect x="112" y="200" width="14" height="14" rx="0"></rect>
  </svg>
);

export const VolumeMuteIcon = ({ width = 20, height = 20 }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 256 256"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    stroke="currentColor"
    stroke-width="5"
    class="raster-icon"
    aria-label="volume-x"
  >
    <rect x="112" y="40" width="14" height="14" rx="0"></rect>
    <rect x="112" y="56" width="14" height="14" rx="0"></rect>
    <rect x="112" y="88" width="14" height="14" rx="0"></rect>
    <rect x="112" y="72" width="14" height="14" rx="0"></rect>
    <rect x="112" y="136" width="14" height="14" rx="0"></rect>
    <rect x="112" y="104" width="14" height="14" rx="0"></rect>
    <rect x="32" y="136" width="14" height="14" rx="0"></rect>
    <rect x="112" y="120" width="14" height="14" rx="0"></rect>
    <rect x="32" y="120" width="14" height="14" rx="0"></rect>
    <rect x="32" y="104" width="14" height="14" rx="0"></rect>
    <rect x="80" y="168" width="14" height="14" rx="0"></rect>
    <rect x="96" y="184" width="14" height="14" rx="0"></rect>
    <rect x="80" y="72" width="14" height="14" rx="0"></rect>
    <rect x="96" y="56" width="14" height="14" rx="0"></rect>
    <rect x="112" y="168" width="14" height="14" rx="0"></rect>
    <rect x="112" y="152" width="14" height="14" rx="0"></rect>
    <rect x="144" y="88" width="14" height="14" rx="0"></rect>
    <rect x="160" y="136" width="14" height="14" rx="0"></rect>
    <rect x="160" y="104" width="14" height="14" rx="0"></rect>
    <rect x="192" y="136" width="14" height="14" rx="0"></rect>
    <rect x="208" y="152" width="14" height="14" rx="0"></rect>
    <rect x="176" y="120" width="14" height="14" rx="0"></rect>
    <rect x="144" y="152" width="14" height="14" rx="0"></rect>
    <rect x="192" y="104" width="14" height="14" rx="0"></rect>
    <rect x="208" y="88" width="14" height="14" rx="0"></rect>
    <rect x="64" y="152" width="14" height="14" rx="0"></rect>
    <rect x="64" y="88" width="14" height="14" rx="0"></rect>
    <rect x="32" y="88" width="14" height="14" rx="0"></rect>
    <rect x="48" y="88" width="14" height="14" rx="0"></rect>
    <rect x="48" y="152" width="14" height="14" rx="0"></rect>
    <rect x="32" y="152" width="14" height="14" rx="0"></rect>
    <rect x="112" y="184" width="14" height="14" rx="0"></rect>
    <rect x="112" y="200" width="14" height="14" rx="0"></rect>
  </svg>
);
